import { render, staticRenderFns } from "./ResumePaymentSlip.vue?vue&type=template&id=b9062f06&"
import script from "./ResumePaymentSlip.vue?vue&type=script&lang=js&"
export * from "./ResumePaymentSlip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports